export var MenuItemCssClass;
(function (MenuItemCssClass) {
    MenuItemCssClass["Base"] = "iress-menu-item";
    MenuItemCssClass["Selected"] = "iress-menu-item--selected";
    MenuItemCssClass["Button"] = "iress-menu-item__button";
    MenuItemCssClass["Header"] = "iress-menu-item__header";
    MenuItemCssClass["Inner"] = "iress-menu-item__inner";
    MenuItemCssClass["HeaderSlots"] = "iress-menu-item__header--slots";
    MenuItemCssClass["Divider"] = "iress-menu-item--divider";
    MenuItemCssClass["MultiSelect"] = "iress-menu-item--multi-select";
})(MenuItemCssClass || (MenuItemCssClass = {}));
export var MenuItemSlot;
(function (MenuItemSlot) {
    MenuItemSlot["Prepend"] = "prepend";
    MenuItemSlot["Append"] = "append";
    MenuItemSlot["IconOnly"] = "icon-only";
})(MenuItemSlot || (MenuItemSlot = {}));
export var MenuItemRole;
(function (MenuItemRole) {
    MenuItemRole["ListItem"] = "listitem";
    MenuItemRole["Option"] = "option";
})(MenuItemRole || (MenuItemRole = {}));
//# sourceMappingURL=menu-item.types.js.map